export var leadPastInteractions = function (data) {
    var pastInteractions = [];
    if (data && data.length > 0) {
        data.map(function (record) {
            var pastObj = {
                leadId: record.leadId,
                createdDate: record.createdDate,
                firstName: record.firstName,
                middleName: record.middleName,
                lastName: record.lastName,
                acCode: record.acCode,
                custType: record.custType,
                dealerEmpName: record.dealerEmpName,
                typeOfContact: record.typeOfContact,
                subCategoryName: record.subCategoryName,
                lastInteractionDate: !!record.lastInteractionDate
                    ? record.lastInteractionDate
                    : "",
                type: record.type,
                amount: !!record.amount
                    ? record.amount === "0"
                        ? ""
                        : record.amount
                    : "",
                subStatus: record.subStatus,
                statusName: record.statusName,
                interaction_sub_status: record.interaction_sub_status,
                followUpDate: !!record.followUpDate ? record.followUpDate : "",
                response: record.response,
                orderId: record.orderId,
                orderStatus: record.orderStatus,
                followupMode: record.followupMode,
                uccCode: record.uccCode,
            };
            pastInteractions.push(pastObj);
        });
    }
    return pastInteractions;
};
